// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__37SVh","label":"SetPasswdForm_label__1VsDk"};